// callback interface for host callback

export var Namespace = /*#__PURE__*/function (Namespace) {
  Namespace["USER_ADDRESS"] = "USER_ADDRESS";
  Namespace["PAYMENT_METHODS"] = "PAYMENT_METHODS";
  Namespace["DROP_IN_PAYMENTS"] = "DROP_IN_PAYMENTS";
  Namespace["ONE_CLICK"] = "ONE_CLICK";
  Namespace["DEFAULT_CHECKOUT"] = "DEFAULT_CHECKOUT";
  Namespace["INTERSTITIAL"] = "INTERSTITIAL";
  return Namespace;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/CallbackUtils/interfaces.js
// module id = 3497
// module chunks = 11